<template>
  <el-card style="height: 710px;overflow-y: scroll;">
    <div class="region">
      <p>单位管理</p>
      <div class="form">
        <el-form :model="searchForm" inline>
          <el-form-item label="单位名称">
            <el-input placeholder="请输入" v-model="searchForm.name" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item label="省份">
            <el-select style="width: 280px;" v-model="searchForm.province">
              <el-option v-for="(item,index) in provinceList" :label="item" :value="item" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="大区">
            <el-select v-model="searchForm.region" style="width: 280px">
              <el-option label="东区" :value="0"></el-option>
              <el-option label="南区" :value="1"></el-option>
              <el-option label="西区" :value="2"></el-option>
              <el-option label="北区" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="toSearch">查看</el-button>
            <el-button @click="searchReset">清空</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-button type="primary" class="add_button" @click="appendRegionShow">新增单位</el-button>
      <el-table border :data="tableData" :header-cell-style="{'background-color': '#f6f6f6'}"
                style="width: 100%;margin-top: 20px;">
        <el-table-column align="center" type="index" width="80px" label="序号"></el-table-column>
        <el-table-column align="center" prop="name" label="单位名称"></el-table-column>
        <el-table-column align="center" prop="province" label="所在省份"></el-table-column>
        <el-table-column align="center" prop="region" label="所在大区">
          <template slot-scope="scope">
            <el-tag type="primary" disable-transitions>
              {{
                scope.row.region === 0 ? '东区' : '' || scope.row.region === 1 ? '南区' : '' || scope.row.region === 2 ? '西区' : '' || scope.row.region === 3 ? '北区' : ''
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="editRegionShow(scope.row)" type="text" class="button">编辑</el-button>
            <el-button v-if="false" @click="deleteRegion(scope.row.id)" type="text" class="button">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="current_page" layout="prev, pager, next" :page-size="pageSize"
                      @current-change="changePage" @prev-click="changePage"
                     @next-click="changePage" :total="total">
      </el-pagination>

      <el-dialog :modal="false" :title="dialogType" class="dialog" :visible.sync="dialogVisible" :show-close="false"
                 @close="closeDialog" width="30%">
        <el-form :model="form">
          <el-form-item label="所在大区">
            <el-select style="width: 80%" v-model="form.region">
              <el-option label="东区" :value="0"></el-option>
              <el-option label="南区" :value="1"></el-option>
              <el-option label="西区" :value="2"></el-option>
              <el-option label="北区" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在省份">
            <el-select style="width: 80%" v-model="form.province">
              <el-option v-for="(item,index) in provinceList" :label="item" :value="item" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单位名称">
            <el-input placeholder="请输入" style="width: 80%" v-model="form.name"></el-input>
          </el-form-item>
        </el-form>
        <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRegionForm">确定</el-button>
        </el-row>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>

import request from "@/utils/request";

export default {
  name: 'RegionView',
  data: function () {
    return {
      provinceList: [
        "北京市", "天津市", "上海市", "重庆市",
        "河北省", "山西省", "辽宁省", "吉林省", "黑龙江省",
        "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省",
        "河南省", "湖北省", "湖南省", "广东省", "海南省",
        "四川省", "贵州省", "云南省", "陕西省", "甘肃省", "青海省",
        "台湾省",
        "内蒙古自治区", "广西壮族自治区", "西藏自治区", "宁夏回族自治区", "新疆维吾尔自治区",
        "香港特别行政区", "澳门特别行政区"
      ],
      tableData: [
        // {name: '仁爱医院', region: '东区', province: '江苏省'},
        // {name: '康宁医院', region: '南区', province: '广东省'},
        // {name: '博爱医院', region: '北区', province: '北京市'}
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      current_page: 1,
      searchForm: {
        name: '',
        region: '',
        province: '',
      },
      form: {
        name: '',
        region: '',
        province: '',
      },
      dialogVisible: false,
      dialogType: '',
    }
  },
  methods: {
    toSearch() {
      this.page = 1
      this.current_page = 1
      this.getRegionData()
    },
    getRegionData() {
      request.get('/admin/unit', {
        params: {
          page: this.page,
          page_size: this.pageSize,
          ...this.searchForm
        }
      }).then((data) => {
        
        if (data['code'] === 200) {
          this.tableData = data['data']
          this.total = data['count']
        }
      })
    },
    searchReset() {
      this.searchForm = {
        name: '',
        region: '',
        province: '',
      }
      this.getRegionData()
    },
    closeDialog() {
      this.form = {
        name: '',
        region: '',
        province: '',
      }
      this.dialogVisible = false
    },
    submitRegionForm() {
      if (this.dialogType === '新增') {
        request.post('/admin/unit', this.form).then((data) => {
          if (data['code'] === 200) {
            this.$message.success(data['message'])
            this.getRegionData()
            this.dialogVisible = false
          } else {
            this.$message.error(data['error'])
          }
        })
      }
      if (this.dialogType === '编辑') {
        console.log(this.form);
        request.put('/admin/unit?id=' + this.form.id, this.form).then((data) => {
          if (data['code'] === 200) {
            this.$message.success('成功')
            this.getRegionData()
            this.dialogVisible = false
          } else {
            this.$message.error(data['error'])
          }
        })
      }
    },
    appendRegionShow() {
      this.dialogType = "新增"
      this.dialogVisible = true
    },
    editRegionShow(row) {
      this.dialogType = "编辑"
      this.form = row
      this.dialogVisible = true
    },
    deleteRegion(id) {
      // request.put(`/admin/user?id=${id}`).then(data => {
      //   if (data['code'] === 200) {
      //     this.$message.success('密码重置成功！')
      //   } else {
      //     this.$message.error(data['error'])
      //   }
      // })
    },
    changePage(page) {
      this.page = page
      this.getRegionData()
    },
  },
  created() {
    this.getRegionData();
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.el-card {
  width: 99%;
}
</style>